import { useQuery } from '@pylot-data/hooks/use-query'
import type {
    CategoryTree,
    CategoryResult,
    Maybe
} from '@pylot-data/pylotschema'
import type { SWRConfiguration } from 'swr'
import { RequestInit } from '@vercel/fetch'
import { GraphQLError } from '@pylot-data/graphqlFetch'
import { navigationMenuWithCMSBlocks } from './graphql/navigationMenuWithCMSBlocks'
import { MenuPreloadVariables } from '@preload/graphql/getConfig.d'

export type NavigationResponse = {
    navigation?: Maybe<CategoryTree>
    isValidating: boolean
    error?: GraphQLError
}

export const useNavMenu = (
    variables?: Maybe<MenuPreloadVariables>,
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
): NavigationResponse => {
    const { data, error, isValidating } = useQuery<
        Maybe<MenuPreloadVariables>,
        { categories: CategoryResult }
    >(navigationMenuWithCMSBlocks, variables, swrOptions, fetchOptions)
    const categories = data?.data?.categories?.items ?? []
    const category = categories[0] as CategoryTree
    return {
        navigation: categories.length ? category : null,
        isValidating,
        error
    }
}
